var productName = 'grid';// Export library
export * from './webpack.entry.js';
// region WebComponents
export { default as WidgetTag } from '../lib/Core/customElements/WidgetTag.js';
// endregion
